<template>
	<img :class="{big:big}" @click="changeImg($event)" src="" />
</template>

<script>
	export default {
		props: {
			big: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			changeImg(e) {
				this.$prompt('新图片的地址', '替换', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({
					value
				}) => {
					e.target.src = value
				}).catch(() => {

				});
			}
		}
	}
</script>

<style scoped >
	img{
		min-height: 20px;
	}
</style>
